module.exports = __webpack_public_path__ + "static/media/atsundown_screen_3.d42f0ee0.webp";